import {determineEngine, Engine, isIframe} from './engine'

/**
 * @readonly
 * @enum {string}
 */
export const PushPluginType = {
    PhonegapNotification: 'phonegap-plugin-push',
    FCMPlugin: 'cordova-plugin-fcm',
    FirebaseJS: 'firebase-js',
    None: 'none',
};

/**
 * Returns the Push plugin that is currently running this app.
 * @return {PushPluginType} PushPluginType
 */
export function determineNotificationPlugin() {

    switch(determineEngine()) {
        case Engine.CORDOVA:

            const metadata = window.cordova.require("cordova/plugin_list").metadata;

            if (metadata[PushPluginType.PhonegapNotification])
                return PushPluginType.PhonegapNotification;
            else if (metadata[PushPluginType.FCMPlugin])
                return PushPluginType.FCMPlugin;
            else
                return PushPluginType.None;

        case Engine.BROWSER:
        default:
            if (isIframe()) {
                return PushPluginType.None;
            } else {
                return PushPluginType.FirebaseJS;
            }
    }
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/plugins.js